/**
 * Reduced full-screen renditions the proxy can add to a channel's session.
 *
 * Why they exist: two 1080p50 pictures at once are a lot for a TV box. The
 * decoder may cope, but every frame also has to be composited by the WebView,
 * and weaker devices (the Google TV boards built into projectors) visibly fall
 * behind. A smaller or slower rendition, encoded on the server's GPU from the
 * same upstream connection, takes that load off the device.
 *
 * "50" and "25" name the full and the halved frame rate of European broadcast.
 * A 60 fps source becomes 60 or 30 instead -- halving keeps every other frame
 * rather than resampling to a fixed rate, which would judder.
 */
export const VARIANT_IDS = ['1080p25', '720p50', '720p25', '540p25'];
export const VARIANTS = {
    '1080p25': { height: 1080, halfRate: true, bitrate: '5000k', label: '1080p · halbe Bildrate' },
    '720p50': { height: 720, halfRate: false, bitrate: '4500k', label: '720p · volle Bildrate' },
    '720p25': { height: 720, halfRate: true, bitrate: '3000k', label: '720p · halbe Bildrate' },
    '540p25': { height: 540, halfRate: true, bitrate: '1800k', label: '540p · halbe Bildrate' },
};
export function isVariantId(value) {
    return typeof value === 'string' && VARIANT_IDS.includes(value);
}
/**
 * The per-device ceiling for full-size slots. 'auto' picks by platform and by
 * how many full-size pictures are on screen, and steps down on its own when the
 * device keeps dropping frames.
 */
export const MAX_QUALITY_IDS = ['auto', 'source', ...VARIANT_IDS];
/** What 'auto' and the step-down walk through, heaviest first. */
export const QUALITY_LADDER = ['source', '720p50', '720p25', '540p25'];
/**
 * The ceiling for full-size slots.
 *
 * `autoMulti` is what 'auto' allows with two or more big pictures on this kind
 * of device. `floor` is the automatic step-down: an index into QUALITY_LADDER
 * that 'auto' stays at or below for the rest of the viewing session. It does
 * not touch an explicit setting -- choosing "Original" means exactly that.
 */
export function ceilingFor(setting, bigSlots, floor, autoMulti) {
    if (setting !== 'auto')
        return setting;
    const base = Math.max(0, QUALITY_LADDER.indexOf(bigSlots >= 2 ? autoMulti : 'source'));
    return QUALITY_LADDER[Math.min(QUALITY_LADDER.length - 1, Math.max(base, floor))];
}
//# sourceMappingURL=renditions.js.map